import 'leaflet';
import 'leaflet.markercluster';

class LocationsContent {
  constructor() {
    const root = document.querySelector('.locations-content');

    if (root) {
      const terms = document.querySelectorAll('.locations-content__term');
      const root = document.querySelector('.locations-content__map');
      const location = document.querySelector('.locations-content__button--location');
      const resize = document.querySelector('.locations-content__button--resize');
      const plus = document.querySelector('.locations-content__button--plus');
      const minus = document.querySelector('.locations-content__button--minus');
      const grid = document.querySelector('.locations-content__grid');
      const cities = document.querySelectorAll('.locations-content__item');

      const map = L.map(root, {
        zoom: 13,
        zoomControl: false,
      });

      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(map);

      const markers = L.markerClusterGroup({
        showCoverageOnHover: false,
        maxClusterRadius: 30,
      }).addTo(map);

      let bounds = [];

      cities.forEach(city => {
        const items = city.querySelectorAll('.locations-content-item');

        items.forEach(item => {
          const marker = L.marker([item.dataset.lat, item.dataset.lng], {
            icon: L.icon({
              iconUrl: root.dataset.marker,
            }),
          });

          marker.bindPopup(`<div class="locations-content-item">${item.innerHTML}</div>`);

          markers.addLayer(marker);

          marker.addEventListener('click', () => {
            map.flyTo(marker.getLatLng());
            marker.openPopup();
          });

          item.addEventListener('click', () => {
            map.flyTo(marker.getLatLng());
            marker.openPopup();
          });
        });

        if (!city.classList.contains('hidden')) {
          items.forEach(item => {
            if (item.dataset.lat && item.dataset.lng) {
              bounds.push([item.dataset.lat, item.dataset.lng]);
            }
          });
        }
      });

      if (bounds.length > 0) {
        map.fitBounds(bounds);
      }

      terms.forEach(term => {
        term.addEventListener('click', e => {
          e.preventDefault();

          terms.forEach(item => {
            if (item == term) {
              item.classList.toggle('active');
            }
            else {
              item.classList.remove('active');
            }
          });

          cities.forEach(city => {
            if (city.dataset.id == term.dataset.id) {
              city.classList.remove('hidden');
            }
            else {
              if (term.classList.contains('active')) {
                city.classList.add('hidden');
              }
              else {
                city.classList.remove('hidden');
              }
            }
          });

          bounds = [];

          cities.forEach(city => {
            const items = city.querySelectorAll('.locations-content-item');

            if (!city.classList.contains('hidden')) {
              items.forEach(item => {
                if (item.dataset.lat && item.dataset.lng) {
                  bounds.push([item.dataset.lat, item.dataset.lng]);
                }
              });
            }
          });

          if (bounds.length > 0) {
            map.fitBounds(bounds);
          }

          window.location.hash = term.dataset.id;
        });

        if (window.location.hash) {
          if (window.location.hash.slice(1) == term.dataset.id) {
            term.dispatchEvent(new Event('click'));
          }
        }
        else {
          if (term.dataset.id == 'wroclaw') {
            term.dispatchEvent(new Event('click'));
          }
        }
      });

      location.addEventListener('click', () => {
        location.classList.add('processing');

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            const marker = L.marker([position.coords.latitude, position.coords.longitude]).addTo(map);

            const content = `
              <div class="locations-content-item">
                <h3 class="locations-content-item__title">Twoja lokalizacja</h3>
              </div>
            `;

            map.flyTo(marker.getLatLng());
            marker.bindPopup(content).openPopup();

            marker.addEventListener('click', () => {
              map.flyTo(marker.getLatLng());
              marker.openPopup();
            });

            location.classList.remove('processing');
            location.classList.add('processed');
          },
          () => {
            console.log("Error: The Geolocation service failed.");

            location.classList.remove('processing');
          });
        } else {
          console.log("Error: Your browser doesn't support geolocation.");

          location.classList.remove('processing');
        }
      });

      resize.addEventListener('click', () => {
        grid.classList.toggle('hidden');
        map.invalidateSize();
      });

      plus.addEventListener('click', () => {
        map.zoomIn();
      });

      minus.addEventListener('click', () => {
        map.zoomOut();
      });
    }
  }
}

export default LocationsContent;
